import { render, staticRenderFns } from "./DropdownSubItem.vue?vue&type=template&id=aa2bfc06&"
import script from "./DropdownSubItem.vue?vue&type=script&lang=js&"
export * from "./DropdownSubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports